import { render, staticRenderFns } from "./DashboardFornecedor.vue?vue&type=template&id=8700b57e"
import script from "./DashboardFornecedor.vue?vue&type=script&lang=js"
export * from "./DashboardFornecedor.vue?vue&type=script&lang=js"
import style0 from "./DashboardFornecedor.vue?vue&type=style&index=0&id=8700b57e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports